import { loadAgenasDiscipline, loadAgenasDisciplineSuccess, loadAgenasDisciplineFailure } from './agenas-discipline.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { AgenasDisciplineState, agenasDisciplineAdapter, agenasDisciplineInitialState } from './agenas-discipline.entity';

export const reducer = createReducer(
  agenasDisciplineInitialState,
  on(loadAgenasDiscipline, (state) => ({ ...state, error: undefined })),
  on(loadAgenasDisciplineSuccess, (state, action) => agenasDisciplineAdapter.setAll(action.datiAgenasDiscipline, state)),
  on(loadAgenasDisciplineFailure, (state, action) => ({ ...state, error: action.error }))
);

export function agenasDisciplineReducer(
  state: AgenasDisciplineState | undefined,
  action: Action
): AgenasDisciplineState {
  return reducer(state, action);
}
